
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5242',
  depVersions: {
  "data-privacy-request-ui": "static-1.5242",
  "data-fetching-client": "static-1.9394",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7703",
  "hub-http-shared-msw-handlers": "static-1.9262",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11141",
  "I18n": "static-7.1549",
  "jasmine-runner": "static-1.6174",
  "privacy-center-public-service-types": "static-1.4505",
  "quartz": "static-1.6605",
  "react-dlb": "static-1.70",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5279",
  "UIComponents": "static-3.8088",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.80",
  "foundations-assets": "static-1.4550",
  "foundations-components": "static-1.7349",
  "foundations-components-test-utils": "static-1.4832",
  "foundations-theming": "static-1.4122",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.383",
  "quartz-core": "static-1.5824",
  "quick-fetch": "static-1.3654",
  "raven": "static-3.5624",
  "react": "static-7.176",
  "react-rhumb": "static-1.16352",
  "SharedI18nStrings": "static-1.179",
  "ui-addon-i18n": "static-1.10846",
  "usage-tracker": "static-1.7053",
  "usage-tracker-anonymous": "static-1.5470",
  "usage-tracker-core": "static-1.6903",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3873",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3153",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2882",
  "quartz-webpack": "static-1.2829",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "HeadJS": "static-2.696",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2814",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3829",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5101",
  "StyleGuideUI": "static-3.482",
  "jasmine": "static-4.4049",
  "rpc-client-utils": "static-1.4325",
  "HubStyle": "static-2.11449",
  "ui-addon-draggable": "static-3.4463",
  "cssUtils": "static-1.708",
  "hs-story-utils": "static-1.9144",
  "icons": "static-2.615",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1068",
  "bend-plugin-foundations-components": "static-1.3618",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1838",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1004",
  "ui-fonts": "static-1.403",
  "bend-plugin-foundations-theming": "static-1.2605",
  "foundations-theming-base": "static-1.3107",
  "stylex": "static-1.26",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.777",
  "hubspotter-http": "static-1.4404",
  "mobile-manifest-mixins": "static-1.469",
  "quartz-auth": "static-1.280",
  "quartz-head": "static-1.270",
  "quartz-i18n": "static-1.280",
  "quartz-routing": "static-1.35",
  "quartz-test": "static-1.280",
  "usage-tracker-container": "static-1.7043",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2832",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.64",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9260"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5242",
  "data-fetching-client": "/data-fetching-client/static-1.9394",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7703",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9262",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11141",
  "I18n": "/I18n/static-7.1549",
  "jasmine-runner": "/jasmine-runner/static-1.6174",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4505",
  "quartz": "/quartz/static-1.6605",
  "react-dlb": "/react-dlb/static-1.70",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5279",
  "UIComponents": "/UIComponents/static-3.8088",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "foundations-assets": "/foundations-assets/static-1.4550",
  "foundations-components": "/foundations-components/static-1.7349",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4832",
  "foundations-theming": "/foundations-theming/static-1.4122",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.383",
  "quartz-core": "/quartz-core/static-1.5824",
  "quick-fetch": "/quick-fetch/static-1.3654",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.176",
  "react-rhumb": "/react-rhumb/static-1.16352",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10846",
  "usage-tracker": "/usage-tracker/static-1.7053",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5470",
  "usage-tracker-core": "/usage-tracker-core/static-1.6903",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3153",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2882",
  "quartz-webpack": "/quartz-webpack/static-1.2829",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "HeadJS": "/HeadJS/static-2.696",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2814",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3829",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5101",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "jasmine": "/jasmine/static-4.4049",
  "rpc-client-utils": "/rpc-client-utils/static-1.4325",
  "HubStyle": "/HubStyle/static-2.11449",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4463",
  "cssUtils": "/cssUtils/static-1.708",
  "hs-story-utils": "/hs-story-utils/static-1.9144",
  "icons": "/icons/static-2.615",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1068",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3618",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1838",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1004",
  "ui-fonts": "/ui-fonts/static-1.403",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2605",
  "foundations-theming-base": "/foundations-theming-base/static-1.3107",
  "stylex": "/stylex/static-1.26",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.777",
  "hubspotter-http": "/hubspotter-http/static-1.4404",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
  "quartz-auth": "/quartz-auth/static-1.280",
  "quartz-head": "/quartz-head/static-1.270",
  "quartz-i18n": "/quartz-i18n/static-1.280",
  "quartz-routing": "/quartz-routing/static-1.35",
  "quartz-test": "/quartz-test/static-1.280",
  "usage-tracker-container": "/usage-tracker-container/static-1.7043",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.64",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9260"
}
};
